// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import ElementUI from 'element-ui';
import './assets/css/theme-green/index.css';
import './assets/css/loading.css';
import store from "./store";
import myUtils from "./util/myUtils"
import { golbalDirective } from './directives/index';
import 'babel-polyfill';
import md5 from 'js-md5';
import Base64 from 'js-base64'
import router from './router'
import App from './App'
import "./element/index"
import { message } from './util/message';
import "./assets/laydate/laydate";
import "./assets/laydate/theme/default/laydate.css"
import plugins from './components/childcomponents/plugins'
import { storage } from "./util/storage"
import './icons'
import * as filters from './filters/index'
import * as echarts from 'echarts'
// import Mock from './mock/index'
import { getScreenColValue } from '@/util'
import animate from "animate.css";

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI, { size: 'mini' });
Vue.prototype.myUtils = myUtils;
Vue.prototype.$md5 = md5;
Vue.prototype.$base = Base64.Base64;
Vue.prototype.$message = message;
Vue.prototype.$col = getScreenColValue();
Vue.use(plugins);
Vue.use(animate)

golbalDirective();
window.storage = new storage();
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  destroyed() {
    window.onresize = null
  },
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js